import * as React from 'react'

import CompanyCard from '../company-card'

import styles from './generic-step.module.scss'
import { ICompanyProps } from '../../dooerPreOffer'

interface IGenericStepProps {
  header: React.ReactNode
  company?: ICompanyProps
  content?: React.ReactNode
  hint?: React.ReactNode
}

const GenericStep = ({ header, content, hint, company }: IGenericStepProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        {header}

        {company && (
          <div className={styles.companyCardWrapper}>
            <CompanyCard company={company} />
          </div>
        )}
      </div>

      <div className={styles.content}>{content}</div>

      {hint && <span className={styles.disclaimer}>{hint}</span>}
    </div>
  )
}

export default GenericStep
